import {find} from '../helpers';

const fade = find('[data-swipe-fade]');
const ticker = find('[data-swipe-ticker]');
const testimonials = find('[data-swipe-testimonials]');

if (fade) {
    import('./fade');
}

if (ticker) {
    import('./ticker');
}

if (testimonials) {
    import('./testimonials');
}
